import {
	UPDATE_ALLERGEN_TRANSLATION,
	SET_ALLERGEN_TRANSLATION,
	RESET_STATE,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
	RE_RENDER_TABLE,
} from './allergenTranslations.actions';

// utils
import _uniqueId from 'lodash/uniqueId';
import moment from 'moment';

const defaultState = {
	tableKey: moment().unix(),
	allergenTranslation: {},
	originalAllergenTranslation: {},
	batchList: [
		{
			identifier: _uniqueId('row-'),
			name: '',
			language: null,
		},
	],
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case RE_RENDER_TABLE:
			return {
				...state,
				tableKey: moment().unix(),
			};

		case SET_ALLERGEN_TRANSLATION:
			return {
				...state,
				allergenTranslation: payload,
				originalAllergenTranslation: payload,
			};

		case UPDATE_ALLERGEN_TRANSLATION:
			return {
				...state,
				allergenTranslation: {
					...state.allergenTranslation,
					...payload,
				},
			};

		case RESET_STATE:
			return defaultState;

		case EDIT_BATCH_LIST_ITEM:
			return {
				...state,
				batchList: state.batchList.map((entry) => {
					if (entry.identifier === payload.identifier) return payload;
					return entry;
				}),
			};

		case REMOVE_BATCH_LIST_ITEM:
			return {
				...state,
				batchList: state.batchList.filter((entry) => entry.identifier !== payload),
			};

		case ADD_BATCH_LIST_ITEM_ROW:
			return {
				...state,
				batchList: [
					...state.batchList,
					{
						...defaultState.batchList[0],
						identifier: _uniqueId('row-'),
					},
				],
			};

		default:
			return state;
	}
}

export default reducer;
